import React, { type HTMLAttributes } from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { AspectRatiosList } from '../../hooks/useLayoutVariables';
import type { MediaReferenceField } from '../../types/uncinc_profile/helpers/media';

import {
  SCREEN_XS,
  SCREEN_SM,
  SCREEN_MD,
  SCREEN_LG,
  SCREEN_XL,
} from '../../config/constants';

interface VariableRatiosPictureProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  image: MediaReferenceField<'image'>;
  aspectRatios: AspectRatiosList
}

const VariableRatiosPicture: React.FC<VariableRatiosPictureProps> = ({
  image,
  aspectRatios,
}) => (
  // For images above the fold, we want to render a Picture component, not an Adaptive Picture.
  // However, when using the DynamicMediaItem with the prop 'aboveTheFold' we would create a sources
  // object consisting of only 'original' ratios because we don't have windowDimensions. (see useLayoutVariables)
  //
  // When the site is loaded by the browser, React recognizes that it should recalculate the imageratios,
  // however, the resulting HTML differs from what's being passed from the server, so React does not replace the HTML.
  //
  // TODO: https://uncinc.monday.com/boards/99020894/pulses/8667876706
  <Image
    src={{
      [SCREEN_XS]: image.styles?.[`ratio_${aspectRatios[0]}_sm`],
      [SCREEN_SM]: image.styles?.[`ratio_${aspectRatios[1]}_md`],
      [SCREEN_MD]: image.styles?.[`ratio_${aspectRatios[2]}_md`],
      [SCREEN_LG]: image.styles?.[`ratio_${aspectRatios[3]}_lg`],
      [SCREEN_XL]: image.styles?.[`ratio_${aspectRatios[4]}_lg`],
    }}
    lazyload={false}
    alt={image.alt}
  />
);

export default VariableRatiosPicture;
